window.dataLayer = window.dataLayer || [];

const gtmBasicFitTech = (() => {
    return {
        init() {
            $(document).on('click', '.js-show-vacancies', () => {
                window.dataLayer.push({
                    event: 'show_vacancies_click'
                });
            });
        
            $('.js-job-vacancies').on('click', e => {
                const $this = $(e.currentTarget);
                const clickedVacancy = $this.find('.js-jobarticle-title').text();
        
                window.dataLayer.push({
                    event: 'highlighted_vacancy_click',
                    vacancy: clickedVacancy
                });
            });
        }
    }
})();

export default (() => {
    $(document).ready(gtmBasicFitTech.init);
})();